import { useAppDispatch, useAppSelector } from 'app/hooks';
import { Modal } from 'components/layout/modal/Modal';
import { Portal } from 'components/other/portal/Portal';
import { Transition } from 'components/other/transition/Transition';
import { selectHotel, closeHotel } from './hotel.slice';
import { HotelBody } from './hotelBody/HotelBody';

export const Hotel = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const hotel = useAppSelector(selectHotel);

  return (
    <Transition active={hotel.ui.hotelIsOpen} timeout={300}>
      {(transitionStyles) => (
        <Portal blocked>
          <Modal
            className={transitionStyles}
            onOverlayClick={() => dispatch(closeHotel())}
          >
            <HotelBody />
          </Modal>
        </Portal>
      )}
    </Transition>
  );
};
